import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { Badge, Button, Modal, Spinner, Table } from 'react-bootstrap';
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux';
import { leaveTypeListTodo } from '../../LMS_Redux/LMS_Slices/Hr/LeaveTypeList';
import { ApplyLeaveSchema } from './HrSchema';
import { checkLeaveEligibilityTodo } from '../../LMS_Redux/LMS_Slices/Hr/CheckLeaveEligibility';
import { applyLeaveRes, applyLeaveTodo } from '../../LMS_Redux/LMS_Slices/Hr/ApplyLeave';
import { toast } from 'react-toastify';
import PropagateLoader from 'react-spinners/PropagateLoader';

function ApplyLeaveModal(props) {

    const { showLeave, setShowLeave, bool, setBool } = props
    const [spinner, setSpinner] = useState(false)
    const [eligibilityLoading, setEligibilityLoading] = useState(false)
    const [eligibility, setEligibility] = useState()
    const dispatch = useDispatch()
    const type = useSelector(state => state?.leaveTypeList?.data?.data)
    // console.log(eligibility)

    const type_option = type?.map(val => (
        { value: val?.vleave_short_name, label: val?.vleave_name }
    ))

    const subType = [
        { value: 'FD', label: 'Full Day' },
        { value: '3HR', label: '3HR' },
        { value: '2HR', label: '2HR' },
    ]

    const handleClose = () => setShowLeave(false);

    const initialValues = {

        leave_type: '',
        sub_type: '',
        date: '',
        remark: ''

    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: ApplyLeaveSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(applyLeaveTodo(values)).then(() => add_res(action))
        },
    })

    const add_res = (action) => {
        if (applyLeaveRes && applyLeaveRes.success) {
            action.resetForm()
            toast.success(applyLeaveRes.message, { position: "bottom-right" })
            setBool(!bool)
            setSpinner(false)
            setShowLeave(false)
            setEligibility()
        } else {
            setSpinner(false)
            toast.error(applyLeaveRes.message, { position: "bottom-right" })
        }
    }

    const check_eligibility = (e) => {
        setEligibilityLoading(true)
        dispatch(checkLeaveEligibilityTodo({ date: e })).then((res) => { setEligibility({ status: res?.payload?.success, message: res?.payload?.message, data: res?.payload?.data }); setEligibilityLoading(false) })
    }

    useEffect(() => {
        dispatch(leaveTypeListTodo())
    }, [])

    return (
        <>
            <Modal show={showLeave} onHide={handleClose} centered backdrop='static' size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Apply Leave</Modal.Title>
                </Modal.Header>
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label form_label">Leave Type</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        options={type_option}
                                        name='leave_type'
                                        onChange={(e) => {
                                            setFieldValue('leave_type', e.value)
                                        }}
                                        onBlur={handleBlur}
                                        placeholder="Select Leave Type"
                                        classNamePrefix="select"
                                    />
                                    {errors.leave_type && touched.leave_type ? (<span className='text-danger form_label'>{errors.leave_type}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label form_label">Leave Sub Type</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        options={subType}
                                        name='sub_type'
                                        onChange={(e) => {
                                            setFieldValue('sub_type', e.value)
                                        }}
                                        onBlur={handleBlur}
                                        placeholder="Select Leave Sub Type"
                                        classNamePrefix="select"
                                    />
                                    {errors.sub_type && touched.sub_type ? (<span className='text-danger form_label'>{errors.sub_type}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label form_label">Date</label>
                                    <input type="date" className="form-control form_input"
                                        name='date' value={values.date} onChange={(e) => { handleChange(e); setFieldValue('date', e?.target?.value); check_eligibility(e?.target?.value) }} onBlur={handleBlur}
                                        min={new Date().toISOString().split('T')[0]}
                                    />
                                    {errors.date && touched.date ? (<span className='text-danger form_label'>{errors.date}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-8">
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label form_label">Remark</label>
                                    <textarea className="form_input form-control" placeholder="Remark" rows={1}
                                        name='remark' value={values.remark || ''} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.remark && touched.remark ? (<span className='text-danger form_label'>{errors.remark}</span>) : null}
                                </div>
                            </div>
                        </div>

                        <div className='text-center'>
                            <Badge pill bg={eligibility?.status ? 'success' : 'danger'}>
                                {eligibility?.message}
                            </Badge>
                        </div>

                        {eligibilityLoading ?
                            <div className='text-center mb-3'>
                                <PropagateLoader
                                    color="#2262C6"
                                    size={20}
                                />
                            </div>
                            :
                            eligibility?.data?.length &&
                            <Table striped bordered hover responsive size="sm" className='mt-2'>
                                <thead>
                                    <tr>
                                        <th>Leave Name</th>
                                        <th>Requested</th>
                                        <th>Approved</th>
                                        <th>Alloted</th>
                                        <th>Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {eligibility?.data?.map((val, index) => (
                                        <tr key={index}>
                                            <td className='fw-medium'>{val?.vleave_name}</td>
                                            <td>{val?.total_leave_requested}</td>
                                            <td>{val?.total_leave_approved}</td>
                                            <td>{val?.total_leave_alloted}</td>
                                            <td>{val?.balance}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" type='submit' disabled={!eligibility?.status || spinner ? true : false}>
                            Submit
                            {spinner ?
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className='ms-2'
                                />
                                : ''
                            }
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
}

export default ApplyLeaveModal;